import { render, staticRenderFns } from "./ObjectSettings.vue?vue&type=template&id=16b70dd4&scoped=true&"
import script from "./ObjectSettings.vue?vue&type=script&lang=ts&"
export * from "./ObjectSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectSettings.vue?vue&type=style&index=0&id=16b70dd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b70dd4",
  null
  
)

export default component.exports